<template>
  <!-- 列表 -->
  <div class="homelist">
    <div v-for="item in list" :key="item.cid">
      <div class="homelist_inner" @click="infobtn(item)">
        <p class="h">{{item.name}}</p>
        <div class="homelist_inner_one">
          <div class="homelist_inner_one_left">
            <img
              src="https://ucenterimage.chinaedu.com/image/user/20200108/23690afd-7c6c-4103-a8c4-09b378cd2848.jpg"
              alt
            />
            <p class="tea">{{item.speak_teacher}}</p>
          </div>
          <div class="homelist_inner_one_right">
            <p>
              ￥
              <span>{{item.price}}</span>
            </p>
            <p class="tea">{{item.livetype}}人已报名</p>
          </div>
        </div>
      </div>
    </div>
    <div class="zanwu">暂无课程</div>
  </div>
</template>

<script>
import URL from "../api/index";
import VueEvent from "../model/VueEvent";
export default {
  data() {
    return {
      list: [],
      httpArr: {
        grade: 1,
        subject: 1,
      },
    };
  },
  computed: {},
  created() {},
  watch: {
    "httpArr.subject"(val) {
      this.httpArr.subject = val;
      this.listconhttp(this.httpArr);
    },
    "httpArr.grade"(val) {
      this.httpArr.grade = val;
      this.listconhttp(this.httpArr);
    },
  },
  mounted() {
    this.listconhttp(this.httpArr);
    var that = this;
    VueEvent.$on("subval", function (sid) {
      that.httpArr.subject = sid;
    });
    VueEvent.$on("gradval", function (gid) {
      //  console.log(gid)
      that.httpArr.grade = gid;
    });
  },
  methods: {
    listconhttp(e) {
      var that = this;
      this.$axios({
        method: "post",
        url: URL.course,
        data: {
          grade: e.grade,
          subject: e.subject,
        },
      }).then((res) => {
        // console.log(res);
        this.list = res.data.result.course;
        // console.log(this.list);
      });
    },
    infobtn(item) {
      this.$router.push({
        name: "classdetails",
        query: {
          cid: item.cid,
          livetype: item.livetype,
          type: item.type,
        },
      });
    },
  },
};
</script>

<style scoped>
.homelist {
  background-color: #fff;
  padding: 0 15px;
  margin-bottom: 30px;
}
.homelist_inner {
  border-top: 1px solid #eee;
}
.h {
  text-align: left;
}
.homelist_inner img {
  width: 40px;
}
.homelist_inner_one {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
}
.homelist_inner_one_right p:first-child {
  color: #f26747;
  text-align: right;
}
.homelist_inner_one_right span {
  font-size: 20px;
}
.tea {
  color: #999;
  font-size: 16px;
  line-height: 16px;
}
.zanwu {
  position: fixed;
  top: 85px;
  left: 160px;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/components/ClassList.vue